import React, { useState, useRef, useEffect } from 'react';

export default function KaraokeUploadFormView1AudioPlayer() {
  const audioPlayerRef = useRef<HTMLAudioElement>(null);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);

  useEffect(() => {
    const audioPlayer = audioPlayerRef.current;
    if (audioPlayer !== null) {
      if (isPlaying) {
        audioPlayer.play();
      } else {
        audioPlayer.pause();
        audioPlayer.currentTime = 0;
      }
    }
  }, [isPlaying]);

  return (
    <>
      <div className="player_button">
        <img
          src={isPlaying ? '/img/karaoke_service/stop.svg' : '/img/karaoke_service/play.svg'}
          alt="再生" 
          style={{ width: '30px' }}
          onClick={() => {
            setIsPlaying(!isPlaying);
          }}
        />
        <span style={{ lineHeight: '1.2em' }}>ボーカル除去のサンプル<br />（除去前〜除去後）</span>
      </div>
      <audio ref={audioPlayerRef} src="/mp3/vocal_less.mp3"></audio>
    </>
  );
}
